module.exports = __webpack_public_path__ + "static/img/no3.3a06eae8.png";